export enum SuggestionType {
    None = 'NONE',
    Drug = 'DRUG',
    Cancer = 'CANCER',
    Included = 'INCLUDED',
    Institution = 'INSTITUTION'
}
